import React, { useEffect, useState } from "react";
import AuthApi from "../services/AuthApi";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { MainNav } from "../mainComponent/mainNav";
import { Wrapper } from "../mainComponent/Wrapper";
import Loader from "../doctor/Dashboard-card/Loader";
import UserLinks from "../doctor/Dashboard-card/partial/uselinks";
import { useRecoilState } from "recoil";
import { setHelperData } from "../recoil/atom/setHelperData";
import { setDoctorId } from "../recoil/atom/setDoctorId";
import clinicLogo from '../../src/img/clinicLogo.png'
function ClinicList() {
    const [clinicData, setClinicData] = useState(null)
    const [doctorName, setDoctorName] = useState([])
    const [isLoading, setIsLoading] = useState(true);
    const [helpersData, setHelpersData] = useRecoilState(setHelperData)
    const [DoctorId, setdoctorId] = useRecoilState(setDoctorId)
    const { getDrInfo } = AuthApi()
    const navigate = useNavigate()

    useEffect(() => {
        doctorData()
    }, []);

    function doctorData() {
        setIsLoading(true);
        const doctorId = DoctorId
        getDrInfo({ doctorId })
            .then((res) => {
                setDoctorName(res.result[0])
                setClinicData(res.result[0].clinicList)
            })
            .finally(() => {
                setIsLoading(false);
            });
    }
    const BookAppointments = (clinicData, e) => {
        e.preventDefault();
        navigate(`bookslot/${clinicData._id}`)
    }
    const goBack = () => {
        navigate(-1)
    }
    return (
        <Wrapper>
            <MainNav>
                <div className="clearfix row">
                        <Link onClick={goBack}>
                            <i className="arrow_back backArrow" title="back button"></i>
                        </Link>
                        <span className='float-none ml-2' style={{ fontSize: 'inherit' }}>Clinic List  </span>
                </div>
            </MainNav>
            <div className=' row'>
                <div className='width_16'>
                    <div className='dash row'>
                        <UserLinks
                            doctorId={DoctorId}
                            helperId={helpersData._id}
                            accessModule={helpersData.access_module}
                        />
                    </div>
                </div>
                <div className="width_84">
                    <div className="common_box p-2">
                        <div className="white-box p-2">
                            {isLoading ?
                                <div className='loader-container'>
                                    <Loader />
                                </div>
                                :
                                <>
                                    {clinicData && clinicData.length > 0 ?
                                        <div className="margin-Left">
                                            {clinicData && clinicData.map((clinicItem, id) => (
                                                <div key={clinicItem._id}>
                                                    <div className='row underline mb-3 pb-3'>
                                                            <figure className="text-align-left  col-sm-3" >
                                                                <img
                                                                    className='clinicLogo borderRadius'
                                                                    src={clinicItem.clinicLogo ||clinicLogo}
                                                                    alt="Clinic Logo"
                                                                />
                                                            </figure>
                                                        <div className=" col-sm-6" align='left' >
                                                            <div className="mb-4">
                                                                <div className='font_weight fontS'>{clinicItem.clinicName}
                                                                    <div className="icon-location fontSize color">
                                                                        {clinicItem.address}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className='text-align-left  col-sm-3' align='right'>
                                                            <NavLink onClick={(e) => BookAppointments(clinicItem, e)}>
                                                                <button className='btn appColor helperBtn'>Book Appointment</button>
                                                            </NavLink>
                                                        </div>

                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        : <div className="clinicHistory mb-3 fontS font-weight" >
                                            Clinics are not available.
                                        </div>
                                    }
                                </>}
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}
export { ClinicList }